import config from "../config";
import { serviceInstance } from "../axiosInterceptor/requestHandler";

const authService = {
  onLogin: (request) =>
    serviceInstance
      .post(`${config.baseurl}/Login `, request)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),


      confirmEmail: (data) =>
      serviceInstance
        .post(`${config.baseurl}/ConfirmEmail`,data)
        .then(({ data, status }) => ({
          ...data,
          status,
        })),

        resetPassword: (data) =>
        serviceInstance
          .post(`${config.baseurl}/ResetPassword`,data)
          .then(({ data, status }) => ({
            ...data,
            status,
          })),

        forgotPassword: (email) =>
        serviceInstance
          .post(`${config.baseurl}/ForgetPassword/${email}`)
          .then(({ data, status }) => ({
            ...data,
            status,
          })),

        resendCode: (email) =>
        serviceInstance
          .post(`${config.baseurl}//ResendActivationEmail/${email}`)
          .then(({ data, status }) => ({
            ...data,
            status,
          })),

  logout: (request) =>
    serviceInstance
      .post(`${config.baseurl}/Account/Logout`,{})
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
};

export default authService;
